import * as React from 'react';
import classNames from 'classnames';
import * as styles from './ServiceLayout.css';

interface IServiceLayoutProps {
  className: string;
  title: React.ReactNode;
  description: React.ReactNode;
  children: React.ReactNode;
}

export const ServiceLayout = ({ title, description, children, className }: IServiceLayoutProps) => {
  return (
    <div className={classNames(styles.root, className)}>
      <div className={styles.heading}>
        <div>{title}</div>
        <div>{description}</div>
      </div>
      <div>{children}</div>
    </div>
  );
};
